import React from 'react';
import { PageHeader } from '../components/layout/PageHeader';
import { InfoCardGrid } from '../components/sections/InfoCardGrid';
import { valuePillars } from '../data/valuePillars';
export function ValuePropositionPage() {
  return <div data-id="element-273" data-mp="1rxj24q3of3ea">
      <PageHeader eyebrow="Strategic Value Proposition & Board Competencies" title="Core Executive Pillars for C-Suite and Board Governance" data-id="element-274" data-mp="1rx9idk985sh1" />
      <section className="bg-white pb-20 lg:pb-28" data-id="element-275" data-mp="107y0ubhazaso">
        <div className="mx-auto max-w-7xl px-6 lg:px-10" data-id="element-276" data-mp="104iovhixehvh">
          <InfoCardGrid items={valuePillars} columns={4} data-id="element-277" data-mp="v93cku0kgu16" />
        </div>
      </section>
    </div>;
}